/**
 * Downloadable files sidebar UI component
 * @param  data 
 * @returns 
 */ 

 import React from "react"
 import _ from 'lodash';
 function DownloadableFiles(data) {
   if(data.data !== null && data.data[0].file !== null) {
     //console.log(data.data)
       const downloadableFiles = data.data.map((download) => {
         
         if(download.file && download.file.localFile !== null) {
           let fileTitle = download.file.localFile.name;
           if(!_.isNil(download.title)) {
              fileTitle = download.title;
           } else if((_.isNil(download.title)) && (!_.isNil(download.file.title))){
              fileTitle = download.file.title;
           } else {
              fileTitle = download.file.localFile.name; 
           }
           return (
             <li className="link-items__link" key={download}>
               <a href={download.file.localFile.localURL}>{fileTitle}</a>
             </li>
           )
         } else{
           return null
         }
         
     }
     );
     return(
       <div className="downloadablefiles">
         <div className="element--inner">
           <p className="heading contact-links__heading">Downloads</p>
           <nav role="navigation" aria-label="Pages in this section">
             <ul className="link-items">
               {downloadableFiles}
             </ul>
           </nav>  
         </div>
       </div>
     )
   } else {
     return null
   }
 }
 export default DownloadableFiles
 
 